import React, { useState } from 'react'
import { Container, Breadcrumb, Meta, User, Button } from '../../../components'
import { useViewport, viewportBreakpoint } from '../../../utils'
import { RegisterPopup } from './register-popup'
import colors from '../../../utils/colors'

const routes = [
  {
    name: 'Home',
    route: '/',
  },
  {
    name: 'Events',
    route: '/event',
  },
  {
    name: 'Upcoming',
    route: '/event',
  }
]

const MainSection = ({data}) => {
  const [show, setShow] = useState(false)
  const special = data.special || false
  const { width } = useViewport()
  const isMobile = width < viewportBreakpoint.tablet
  const height = isMobile ? '235px' : '470px'

  return (
    <Container className="py-6 md:py-10 lg:py-20" color="#f5f5f5">
      <div className="flex flex-wrap -mx-4">
        <div className="w-full lg:w-7/12 px-4 mb-4 lg:mb-0">
          <div
            className="bg-no-repeat bg-cover bg-center rounded"
            style={{backgroundImage: `url('${data.image}')`, height: height}}
          />
        </div>
        <div className="w-full lg:w-4/12 px-4 lg:ml-auto">
          <div className="mb-2 lg:mb-4">
            <Breadcrumb routes={routes} />
          </div>
          <div className={`${special && isMobile ? 'flex' : ''}`}>
            <p className="text-sm font-bold mb-3 lg:mb-5">{data.date}</p>
            {
              special &&
              <div className={`rounded px-1 text-white text-xs mb-5 inline-block ${isMobile ? 'ml-2' : ''}`} style={{background: '#FF5448'}}>
                Special Event
              </div>
            }
          </div>
          <h1 className="text-2xl lg:text-4xl font-bold font-primary mb-5 lg:mb-8 leading-tight">
            {data.title}
          </h1>

          {/* <div style={{marginBottom: '48px'}} className="hidden lg:block">
            <User />
          </div> */}

          <div className="lg:w-full flex flex-wrap -mx-4 mb-2">
            {/* <div className="w-1/2 px-4 hidden lg:block">
              <Meta
                className="mb-4 lg:mb-8"
                label="Resource Type"
                value="Berita, Bahan"
              />
            </div> */}
            {/* <div className="w-full lg:w-1/2 px-4">
              <Meta
                className="mb-4 lg:mb-8"
                label="Suitable for"
                value="Educator, Donor, Professionals"
              />
            </div> */}
            {
              data.approach &&
              <div className="w-1/2 px-4">
                <Meta
                  className="mb-6 lg:mb-8"
                  label="Approach"
                  value={data.approach}
                />
              </div>
            }
            {
              data.issues &&
              <div className="w-1/2 px-4">
                <Meta
                  className="mb-6 lg:mb-8"
                  label="Issues"
                  value={data.issues}
                />
              </div>
            }
          </div>
          <div className="mb-6 lg:hidden">
            <User />
          </div>
          <div onClick={() => setShow(true)}>
            <Button className="mb-8 hidden lg:block">
              Submit to this event
            </Button>
            <div className="lg:hidden">
              <Button thin className="mb-4">
                Submit to this event
              </Button>
            </div>
          </div>

          <hr className="my-5 lg:my-10"/>
          <div className="mb-5">
            <p className="text-sm lg:text-xs font-bold mb-5 text-center lg:text-left">Share this event</p>
            <div className="flex items-center -mx-2 justify-center lg:justify-start">
              <div className="w-1/4 px-2">
                <div
                  className="rounded border text-primary text-xs text-center px-2 py-1 cursor-pointer"
                  style={{borderColor: colors.primary}}
                >
                  Copy
                </div>
              </div>
              <div className="w-auto px-2">
                <div className="flex items-center">
                  <img className="mr-2 cursor-pointer" src="/images/logos/khub_facebook-logo.svg" alt="facebook"/>
                  <img className="mr-2 cursor-pointer" src="/images/logos/khub_twitter.svg" alt="twitter"/>
                  <img className="mr-2 cursor-pointer" src="/images/logos/khub_linkedin.svg" alt="linkedin"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {
        show &&
        <RegisterPopup onClose={setShow} isMobile={isMobile} data={data}/>
      }
    </Container>
  )
}

export { MainSection }
